import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  FETCH_CRQ_VIEW_EDIT_REQUEST,
  FETCH_CRQ_VIEW_EDIT_SUCCESS,
  FETCH_CRQ_VIEW_EDIT_ERROR,
  SAVE_EDIT_FORM_DATA,
  SET_RISK_VALUE_FOR_EDIT_FORM,
  SAVE_SECTION_DATA_FOR_EDIT_FORM,
  CHANGE_COORDINATOR_FOR_EDIT_CRQ_ID,
  CHANGE_STATUS_REASON_FOR_EDIT_CRQ_ID,
  CHANGE_STATUS_FOR_EDIT_CRQ_ID,
  CHANGE_PEER_REJECTION_REASON_FOR_EDIT_CRQ,
  SUBMIT_EDIT_FORM_REQUEST,
  SUBMIT_EDIT_FORM_SUCCESS,
  SUBMIT_EDIT_FORM_ERROR,
  CLEAR_SUBMIT_EDIT_FORM_ERROR,
  SAVE_EDIT_FORM_SECTION_ERRORS,
  CLEAR_EDIT_FORM_ERRORS,
  MARK_EDIT_SECTION_AS_READ,
  CLEAR_EDIT_SECTIONS_READ,
  SET_PEER_REVIEWER_GROUP_FOR_EDIT_CRQ_ID,
  SET_PEER_REVIEWER_FOR_EDIT_CRQ_ID,
  SET_SPONSOR_EDIT_FORM,
  SET_UNSAVED_RELATIONSHIPS_EDIT_FORM,
  HACK_BOI_FOR_APPROVERS_ACTIONABLE,
  CLEAR_ADJACENT_REMEDY_REF,
} from 'AppSrc/core/actions/actions-edit-form';


const editFormDefaultState = {
  formDataById: {
  },
  fetchingById: {
  },
};

const setFetchingForCrq = (fetching) => (state, action) => ({
  ...state,
  fetchingById: {
    ...state.fetchingById,
    [action.payload.crqId]: fetching,
  },
});



const saveEditFormData = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      ...action.payload.formData,
    },
  },
});

const setRiskValueForEditForm = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      riskValue: action.payload.riskValue,
    },
  },
});


const changeCoordinatorForEditCrqId = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      coordinatorGroup: action.payload.groupName,
      coordinatorId: action.payload.coordinatorId,
      coordinatorName: action.payload.coordinatorName,
    },
  },
});

const saveSectionDataForEditForm = (state, action) => {
  const {
    crqId,
    sectionData,
  } = action.payload;

  return ({
    ...state,
    formDataById: {
      ...state.formDataById,
      [crqId]: {
        ...state.formDataById[crqId],
        dataByFormSectionId: {
          ...state.formDataById[crqId].dataByFormSectionId,
          [sectionData.sectionId]: {
            ...sectionData,
          },
        },
      },
    },
  });
};





const changeStatusReasonForEditCrqId = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      statusReason: action.payload.statusReason,
    },
  },
});

const changeStatusForEditCrqId = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      status: action.payload.status,
    },
  },
});

const changePeerRejectionReasonForEditCrqId = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      peerRejectionReason: action.payload.peerRejectionReason,
    },
  },
});

const setPeerReviewerGroupForEditCrqId = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      peerReviewerGroup: action.payload.groupName,
      peerReviewerName: null,
      peerReviewerId: null,
    },
  },
});

const setPeerReviewerForEditCrqId = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      peerReviewerName: action.payload.name,
      peerReviewerId: action.payload.id,
    },
  },
});

const setSponsor = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      unsavedSponsorValue: action.payload.sponsor,
    },
  },
});

const setUnsavedRelationships = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      unsavedRelationships: action.payload.unsavedRelationships,
    },
  },
});





const submitEditFormRequest = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      isSubmitting: true,
      submitError: null,
    },
  },
});

const submitEditFormSuccess = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      isSubmitting: false,
      // also means we've updated the sponsor to the database
      // so we can set sponsor back to null
      unsavedSponsorValue: null,
    },
  },
});

const submitEditFormError = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      isSubmitting: false,
      submitError: action.payload.error,
    },
  },
});

const clearSubmitError = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      submitError: null,
    },
  },
});






const setViewCrqErrorsForSection = (state, action) => {
  const { crqId, sectionId, errors } = action.payload;
  return ({
    ...state,
    formDataById: {
      ...state.formDataById,
      [crqId]: {
        ...state.formDataById[crqId],
        summaryErrors: {
          ...state.formDataById[crqId].summaryErrors,
          [sectionId]: { ...errors },
        },
      },
    },
  });
};



const clearViewCrqErrors = (state, action) => {
  const { crqId } = action.payload;
  return ({
    ...state,
    formDataById: {
      ...state.formDataById,
      [crqId]: {
        ...state.formDataById[crqId],
        summaryErrors: {},
      },
    },
  });
};


const markEditSectionAsRead = (state, action) => {
  const { crqId, sectionId } = action.payload;
  return ({
    ...state,
    formDataById: {
      ...state.formDataById,
      [crqId]: {
        ...state.formDataById[crqId],
        summarySectionsRead: {
          ...state.formDataById[crqId].summarySectionsRead,
          [sectionId]: true,
        },
      },
    },
  });
};

const clearEditSectionsRead = (state, action) => {
  const { crqId } = action.payload;
  return ({
    ...state,
    formDataById: {
      ...state.formDataById,
      [crqId]: {
        ...state.formDataById[crqId],
        summarySectionsRead: {},
      },
    },
  });
};

const hackBoiForApproversActionable = (state, action) => {
  const { crqId } = action.payload;

  const oldApprovalHistory = state.formDataById[crqId].approvalHistory ? state.formDataById[crqId].approvalHistory : [];

  const approvalHistory = oldApprovalHistory.map((historyItem) => {
    const hasSignature = historyItem.signature ? true : false;

    if (hasSignature) {
      return ({
        ...historyItem,
        actionable: true,
      });
    }

    return historyItem;
  });


  return ({
    ...state,
    formDataById: {
      ...state.formDataById,
      [crqId]: {
        ...state.formDataById[crqId],
        approvalHistory,
      },
    },
  });
};

const clearAdjacentRemedyRefFromFormData = (state, action) => ({
  ...state,
  formDataById: {
    ...state.formDataById,
    [action.payload.crqId]: {
      ...state.formDataById[action.payload.crqId],
      adjacentRemedyRef: null,
    },
  },
});

const actionHandlers = {
  [FETCH_CRQ_VIEW_EDIT_REQUEST]: setFetchingForCrq(true),
  [FETCH_CRQ_VIEW_EDIT_SUCCESS]: setFetchingForCrq(false),
  [FETCH_CRQ_VIEW_EDIT_ERROR]: setFetchingForCrq(false),
  [SAVE_EDIT_FORM_DATA]: saveEditFormData,
  [SET_RISK_VALUE_FOR_EDIT_FORM]: setRiskValueForEditForm,
  [CHANGE_COORDINATOR_FOR_EDIT_CRQ_ID]: changeCoordinatorForEditCrqId,
  [SET_PEER_REVIEWER_GROUP_FOR_EDIT_CRQ_ID]: setPeerReviewerGroupForEditCrqId,
  [SET_PEER_REVIEWER_FOR_EDIT_CRQ_ID]: setPeerReviewerForEditCrqId,
  [SAVE_SECTION_DATA_FOR_EDIT_FORM]: saveSectionDataForEditForm,
  [CHANGE_STATUS_REASON_FOR_EDIT_CRQ_ID]: changeStatusReasonForEditCrqId,
  [CHANGE_STATUS_FOR_EDIT_CRQ_ID]: changeStatusForEditCrqId,
  [CHANGE_PEER_REJECTION_REASON_FOR_EDIT_CRQ]: changePeerRejectionReasonForEditCrqId,
  [SUBMIT_EDIT_FORM_REQUEST]: submitEditFormRequest,
  [SUBMIT_EDIT_FORM_SUCCESS]: submitEditFormSuccess,
  [SUBMIT_EDIT_FORM_ERROR]: submitEditFormError,
  [CLEAR_SUBMIT_EDIT_FORM_ERROR]: clearSubmitError,
  [SAVE_EDIT_FORM_SECTION_ERRORS]: setViewCrqErrorsForSection,
  [CLEAR_EDIT_FORM_ERRORS]: clearViewCrqErrors,
  [MARK_EDIT_SECTION_AS_READ]: markEditSectionAsRead,
  [CLEAR_EDIT_SECTIONS_READ]: clearEditSectionsRead,
  [SET_SPONSOR_EDIT_FORM]: setSponsor,
  [SET_UNSAVED_RELATIONSHIPS_EDIT_FORM]: setUnsavedRelationships,
  [HACK_BOI_FOR_APPROVERS_ACTIONABLE]: hackBoiForApproversActionable,
  [CLEAR_ADJACENT_REMEDY_REF]: clearAdjacentRemedyRefFromFormData,
};

const editFormReducer = createReducer(editFormDefaultState, actionHandlers);

export {
  editFormDefaultState,
  editFormReducer,
};





